import { LIST_GC_TIME_MS, LIST_STALE_TIME_MS, useApiClient } from '@klareospace/pharos-lib-front-utils';
import type { TemplateWithContent } from '@klareospace/pharos-lib-types';
import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { createTemplateApi, templateKeys } from '../../catalog/api';

// ─── Hook ─────────────────────────────────────────────────────────────────────

export function useTemplateWithContent(templateId: string | null): UseQueryResult<TemplateWithContent> {
  const client = useApiClient('deliveries');
  const api = createTemplateApi(client);

  return useQuery({
    enabled: templateId !== null && templateId.length > 0,
    gcTime: LIST_GC_TIME_MS,
    queryFn: () => api.getTemplateById(templateId!),
    queryKey: templateKeys.detail(templateId ?? ''),
    staleTime: LIST_STALE_TIME_MS,
  });
}
